/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import isArguments from"./isArguments";import isArray from"./isArray";const baseFlatten=function(t,e,r,n){let s=(n||0)-1,l=t.length,o=-1,a=[];for(;++s<l;){let n=t[s];if(n&&"object"==typeof n&&"number"==typeof n.length&&(isArray(n)||isArguments(n))){e&&(n=baseFlatten(n,e,r));let t=-1,s=n.length;for(a.length+=s;++t<s;)a[++o]=n[t]}else r||(a[++o]=n)}return a};export default baseFlatten;